// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".start[data-v-81d1fb5c]{overflow:hidden}.start__button[data-v-81d1fb5c]{position:absolute;bottom:3.2rem;right:3.2rem}.grid-small[data-v-81d1fb5c]{margin-top:6.4rem}", ""]);
// Exports
module.exports = exports;
